<template>
  <div class="course-content-wrapper">
    <div class="container">
      <div class="row course-item-wrap">
        <div class="col-lg-12">
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane fade show active" id="tab1">
              <div class="row course-block">
                <div class="col-lg-3 col-md-4 col-sm-6" :class="{'col-lg-4 col-md-6 col-sm-12 ':$route.name == 'learning'}" v-for="(item,index) in listArr.courses" :key="index">
                  <div class="course-item" @click="toDetails(item.courseId,item.courseStatus,item)">
                    <div class="course-img">
                      <a class="course__img">
                        <img :src="item.courseImg" :alt="item.courseName" />
                      </a>
                    </div>
                    <!-- 其他页面样式 -->
                    <div class="course-content" v-if="$route.name != 'course' && $route.name != '/'">
                      <p class="course__label">
                        <!-- <span class="course__label-text">{{item.menuName}}</span> -->
                        <a
                          class="course__collection-icon"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Add to Wishlist"
                        >
                          <span class="la la-heart-o"></span>
                        </a>
                      </p>
                      <h3 class="course__title" :title="item.courseName">{{item.courseName}}</h3>
                      <p class="course-info" :class="item.recommendIntroduction == null ? 'no-data' : ''" :title="item.recommendIntroduction">{{item.recommendIntroduction}}</p>
                      <div class="course__author" v-if="listArr.courseStyle == 1 || $route.name == 'learning'">
                        <div class="" v-if="$route.name == 'learning'">
                          <div class="currProgress">
                            <span style='color:#E88F34;'>{{item.learnedBarrierCount}}</span><span>/{{item.barrierCount}}</span>
                          </div>
                        </div>
                        <div class="" v-else>
                          <span class="course__price" v-if="item.free">免费</span>
                          <span class="course__price" v-else>{{item.currentPrice}}</span>
                        </div>
                        <span class="meta__date">
                          {{item.barrierCount}}个关卡
                        </span>
                      </div>
                    </div>
                    <!-- 首页样式 -->
                    <div class="course-content course-content-items" v-if="$route.name === '/'">
                      <h3 class="course-name-box" :title="item.courseName">{{item.courseName}}</h3>
                      <div class="coourse-barrier">
                        <p class="text">共{{item.barrierCount}}关</p>
                      </div>
                      <p class="course-info" :class="item.recommendIntroduction == null ? 'no-data' : ''" :title="item.recommendIntroduction">{{item.recommendIntroduction}}</p>
                    </div>
                    <!-- 课程库样式 -->
                    <div class="course-content course-content-items" v-if="$route.name === 'course'">
                      <h3 class="course-name-box" :title="item.courseName">{{item.courseName}}</h3>
                      <div class="coourse-barrier">
                        <p><span>{{item.barrierCount}}</span>个关卡</p>
                        <div class="type-tips" v-if="item.sceneCourse && item.sceneId">“学习路线”课程</div>
                      </div>
                      <p class="course-info" :class="item.recommendIntroduction == null ? 'no-data' : ''" :title="item.recommendIntroduction">{{item.recommendIntroduction}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import("@/assets/style.css");
import { zhugeTrack, getInterval, isMobile } from "@/../public/public";
import { Message } from 'element-ui';
import { axios } from '@/../api/init';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
export default {
  name: "list",
  props: ["listArr"],
  data() {
    return {
      noClick:true,
    };
  },
  mounted() {
    // console.log(this.listArr)
  },
  methods: {
   // 获取sign
    getSign() {
      var cookie = this.getCookie("_uc_t_");
      if (cookie != null) {
        var arr = cookie.split(";");
        return arr[2];
      }
      return null;
    },
    toDetails(id, type, data) {
      if (this.$route.name != "learning") {
        // 无需判断是否为学习路线课程（2021年5月24日）
        // 判断是否是学习路线课程/是否需要解锁/是否已经解锁/是否已经报名 （2021年5月24日之前）
        // if(data.sceneCourse && data.courseUnlock && !data.unlockFlag && !data.own){
        //   this.$router.push({
        //     path:'/sceneDetails',
        //     query:{
        //       sceneId: data.sceneId
        //     }
        //   })
        //   return
        // }
        
        // 无需判断是否有详情页（2021年4月21日）
        // window.open(data.sceneCourse && data.sceneStepId ? "/detail/" + id + '.html?sceneStepsId=' + data.sceneStepId : "/detail/" + id + '.html');
        
        // 无需判断是否为学习路线课程（2021年5月24日）
        window.open(`/detail/${id}.html`);
        let zhugeObj = {
          课程id: data.courseId,
          课程名称: data.courseName,
          课程学科: data.menuName,
          课程关卡数: getInterval(data.barrierCount)
        };
        zhugeTrack("Web_课程库页-点击课程", zhugeObj);


        // 是否有详情页（2021年4月21日之前）
        // if(data.detailFlag){
        //   window.open(data.sceneCourse && data.sceneStepId ? "/detail/" + id + '.html?sceneStepsId=' + data.sceneStepId : "/detail/" + id + '.html');
        //   let zhugeObj = {
        //     课程id: data.courseId,
        //     课程名称: data.courseName,
        //     课程学科: data.menuName,
        //     课程关卡数: getInterval(data.barrierCount)
        //   };
        //   zhugeTrack("Web_课程库页-点击课程", zhugeObj);
        // }else{
        //   // 是否报名了
        //   if(data.own){
        //     // 跳关卡
        //     window.open("/barrier.html#/?courseId=" + id);
        //   }else{
        //     // 下单买课
        //     this.freeToStudy(data.sceneStepId ,id)
        //   }
        // }

      } else {
        window.open(`/barrier.html#/?courseId=${id}&source=true`);
        let zhugeObj = {
          课程id: data.courseId,
          课程名称: data.courseName,
          课程学科: data.menuName,
          课程状态: data.learnStatus == 2 ? "已学完" : "学习中",
          课程关卡数: getInterval(
            data.learnPosition.substr(data.learnPosition.indexOf("/") + 1)
          )
        };
        zhugeTrack("Web_当前学习页-点击课程", zhugeObj);
      }
    },
    // 开始学习
    freeToStudy(sceneStepsId, courseId){
      if(isMobile()){
        window.location.href = "/qrcode.html#/"
        return
      }
      
      if(!this.noClick){
        return
      }
      axios({
        url: VUE_APP_BASE_PATH_ONLINE + "/online/user/isAlive",
        method: "GET"
      }).then(res => {
        if(res.data.success){
          if(this.noClick){
            let sign =  this.getSign()//解析cookie中的sign
            this.noClick = false
            axios({
              url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/to-learn",
              method: "POST",
              headers: {
                // 'data-Type': "json",
                'Content-Type':'application/json'
              },
              // data: JSON.stringify(JSON.parse("{\"totalAmount\":0,\"courseCoupon\":{\"" + courseId + "\":0}},")),
              params:{sign: sign},
              data:{studentId:res.data.resultObject.id,courseId:courseId}
            }).then(res=>{
              let data = res.data
              if (data.status == 200) {
                if(isMobile()){
                  window.location.href = "/qrcode.html#/"
                  this.noClick = true
                }else{
                  // this.sceneSubscribe()
                  setTimeout(function () {
                    let str = sceneStepsId ? '&sceneStepsId=' + sceneStepsId : ''
                    window.location.href = `/barrier.html#/?courseId=${courseId}${str}`
                    this.noClick = true
                  }, 1200);
                }
              } else {
                Message.error(data.message)
                this.noClick = true
              }
            })
          }
        }else{
          if(isMobile()){
            window.location.href = "/qrcode.html#/"
          }else{
            window.location.href = VUE_APP_BASE_PATH_PASSPORT + "/user/login?refer=" + encodeURIComponent(window.location.href) + '&codeLogin=true'            
          }
        }
      })
    },
  },
  watch:{
    listArr(data){
      // console.log(data)
    }
  }
};
</script>

<style lang="less" scoped>
.title-box {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    h2 {
      font-size: 16px;
      color: #2A3C60;
      line-height: 22px;
      margin:0;
    }
    > span {
      margin-left: 20px;
      color: #999;
      font-size: 12px;
      line-height: 22px;
    }
  }
/*============ course-block ============*/
.course-block{
  // margin-bottom: 20px;
  .col-lg-3{
    padding:0 11px;
  }
}
.course-block .course-item {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 30px;
  max-width: 370px;
  margin: 0 auto 30px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  cursor: pointer;
}
.course-block .course-item .course-img {
  position: relative;
  a {
    cursor: pointer;
  }
  .course__img {
    display: block;
  }
  
}
.course-block .course-item .course-img .course__img img {
  width: 100%;
  max-height: 226px;
  display: block;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}
.course-block .course-item .course-img .course-tooltip {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}
.course-block .course-item .course-img .course-tooltip .tooltip-label {
  background-color: #25c48b;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
  padding: 4px 10px 4px 12px;
  -webkit-border-radius: 4px 4px 4px 0;
  -moz-border-radius: 4px 4px 4px 0;
  border-radius: 4px 4px 4px 0;
  font-size: 12px;
  position: relative;
}
.course-block .course-item .course-img .course-tooltip .tooltip-label:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 6px;
  z-index: -1;
  background-color: #25c48b;
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-transform: skew(12deg, 0deg);
  -moz-transform: skew(12deg, 0deg);
  -ms-transform: skew(12deg, 0deg);
  -o-transform: skew(12deg, 0deg);
  transform: skew(12deg, 0deg);
  -webkit-border-radius: 4px 0 0 0;
  -moz-border-radius: 4px 0 0 0;
  border-radius: 4px 0 0 0;
}
.course-block .course-item .course-img:after {
  position: absolute;
  bottom: 0;
  left: 30px;
  content: "";
  width: 0;
  height: 0;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-bottom: 13px solid #fff;
}
.course-block .course-item .course-content {
  border: 1px solid rgba(127, 136, 151, 0.2);
  -webkit-border-radius: 0 0 4px 4px;
  -moz-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
  padding: 24px 20px;
  border-top: transparent;
  background: #fff;
  
}
.course-block .course-item .course-content .course__label {
  font-weight: 500;
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin: 0;
}
.course-block .course-item .course-content .course__label .course__label-text {
  background-color: rgba(81, 190, 120, 0.1);
  display: inline-block;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  color: #25c48b;
  padding: 1px 12px;
  line-height: 20px;
  text-transform: capitalize;
  font-size: 14px;
  max-width: 100%;
  text-overflow:ellipsis;  
  overflow: hidden;  
  white-space: nowrap;
}
.course-block
  .course-item
  .course-content
  .course__label
  .course__collection-icon {
  margin-left: auto;
  color: #7f8897;
  font-size: 22px;
  position: relative;
}
.course-block
  .course-item
  .course-content
  .course__label
  .course__collection-icon:after {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  content: "\f233";
  font-family: "LineAwesome";
  color: #25c48b;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  opacity: 0;
  visibility: hidden;
}
.course-block
  .course-item
  .course-content
  .course__label
  .course__collection-icon:hover:after {
  opacity: 1;
  visibility: visible;
}
// 课程名称
.course-block .course-item .course-content .course__title {
  font-size: 16px;
  font-weight: 600;
  height: 44px;
  margin: 0px 0 10px;
  line-height: 22px;
  color: #233d63;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  &:hover {
    color: #25c48b;
  }
}

.course-block .course-item .course-content{
  // 课程介绍  
  .course-info{
    text-overflow:ellipsis;  
    overflow: hidden;  
    white-space: nowrap;
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #818896;
    line-height: 18px;
    height: 18px;
  }
  .course__author {
    margin-top: 18px;
    display: flex;
    justify-content: space-between;
    line-height: 22px;
    // 价格
    .course__price{
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #e88f34;
    }
    // 学习人数
    .meta__date{
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #818896;
    } 
  }
} 
.course-block .course-item .course-content .course__author a {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #818896;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.course-block .course-item .course-content .course__author a:hover {
  color: #25c48b;
}
.course-block .course-item .course-content .course-meta {
  margin-bottom: 17px;
}
.course-block .course-item .course-content .course-meta .course__list {
  margin: 0;
}
.course-block .course-item .course-content .course-meta .course__list li {
  width: 100%;
  border-right: 1px solid rgba(127, 136, 151, 0.2);
  padding: 0 15px;
}
.course-block
  .course-item
  .course-content
  .course-meta
  .course__list
  li:first-child {
  padding-left: 0;
}
.course-block
  .course-item
  .course-content
  .course-meta
  .course__list
  li:last-child {
  border-right: none;
  padding-right: 0;
  text-align: left;
}
.course-block .course-item .course-content .course-meta .course__list li span {
  display: block;
}
.course-block
  .course-item
  .course-content
  .course-meta
  .course__list
  li
  span.meta__date {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #233d63;
  font-weight: 500;
  line-height: 20px;
}
.course-block
  .course-item
  .course-content
  .course-meta
  .course__list
  li
  span.meta__text {
  font-weight: 500;
  font-size: 15px;
}
.course-block .course-item .course-content .course-price-wrap {
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  .currProgress{
    span{
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #000000;
    }
  }
}
.course-block .course-item .course-content .course-price-wrap .course__price {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #E88F34;
}
.course-block
  .course-item
  .course-content
  .course-price-wrap
  .course__price
  .course__before-price {
  font-size: 16px;
  margin-right: 3px;
  color: #7f8897;
  text-decoration: line-through;
}
.course-block .course-item .course-content .course-price-wrap .course__btn {
  font-family: PingFangSC-Regular;
  margin-left: auto;
  width: 77px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  background: #25c48b;
  border-radius: 4px;
  cursor: pointer;
  &:hover{
    text-decoration:none;
    background: #28D899;
  }
}
.course-block .course-item:hover {
  -webkit-box-shadow: 0 0 40px rgba(82, 85, 90, 0.1);
  -moz-box-shadow: 0 0 40px rgba(82, 85, 90, 0.1);
  box-shadow: 0 0 40px rgba(82, 85, 90, 0.1);
}



// 课程库样式
.course-content-items{
  padding: 20px !important;
  cursor: pointer;
  .course-name-box{
    margin-bottom: 10px;
    height: 44px;
    line-height: 22px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #2a3c60;
    text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .coourse-barrier{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    p{
      height: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      line-height: 20px;
      margin: 0;
      color: #1d3156;
      span{
        color: #25c48b;
      }
    }
    .type-tips{
      padding: 0 10px;
      height: 20px;
      line-height: 20px;
      background: #f6f7f7;
      border-radius:10px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #25c48b;
    }
  }
  .course-info{
    margin: 30px 0 0;
    height: 28px;
    padding: 0 13px;
    background-color: #fff7f0;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #e88f34;
    line-height: 28px;
    text-overflow:ellipsis;  
    overflow: hidden;  
    white-space: nowrap;
  }
  .no-data{
    background: transparent !important;
  }
}



// @media only screen and (min-width: 768px) and (max-width: 991px) {
//       .benefit-area .benefit-img img {
//         position: inherit; } }

.course-content-wrapper {
  @media (min-width: 1200px) {
    .container {
      max-width: 1192px;
    }
  }
  // @media (min-width: 992px){
  //   .container{
  //     
  //   }
  // }
}

@media (max-width: 1199px) {
  .container{
    width: 100% !important;
    max-width:100% !important;
    padding: 0 30px
  }
}
@media (max-width: 991px) {
  .container{
    width: 100% !important;
    max-width:100% !important;
    padding: 0 20px;
  }
}
</style>